import {
  MONO_API,
  LAMBDA_AUTH_HEADER,
  LAMBDA_AUTH_HEADER_VALUE
} from '@/config/appConfig';

const apiRequest = async ({
  url, method, body, headers,
}) => {
  const response = await fetch(
    url,
    {
      headers,
      method,
      credentials: 'include',
      mode: 'cors',
      body: body ? JSON.stringify(body) : undefined,
    },
  );

  if (!response.ok) {
    throw new Error('Failure to successfully execute API request');
  }

  return response;
};

export const getUploadUrl = async (file, tagboardId) => {
  const fileExtension = file.type.split('/')[1];
  const body = {
    tagboardId,
    fileName: file.name,
    fileExtension,
    processWithTrigger: false,
  };

  try {
    const response = await apiRequest({
      url: `${MONO_API}/public/shareit/upload`,
      method: 'POST',
      body,
      headers: {
        'Content-Type': 'application/json',
        [LAMBDA_AUTH_HEADER]: LAMBDA_AUTH_HEADER_VALUE,
      },
    });

    return await response.json();
  } catch (error) {
    console.error(error);
    throw new Error('Failed to get upload url');
  }
};

export const uploadFile = async (uploadUrl, file) => {
  const xhr = new XMLHttpRequest();
  xhr.open('PUT', uploadUrl);
  xhr.setRequestHeader('Content-Type', 'application/octet-stream');
  await new Promise((resolve, reject) => {
    xhr.onload = () => ((xhr.status - 200) < 100 ? resolve() : reject(new Error('Failed to upload')));
    xhr.onerror = () => reject(new Error('Failed to upload'));
    xhr.send(file);
  });
};

export const submitShareit = async (payload) => {
  try {
    const response = await apiRequest({
      url: `${MONO_API}/public/shareit/submit`,
      method: 'POST',
      body: payload,
      headers: {
        'Content-Type': 'application/json',
        [LAMBDA_AUTH_HEADER]: LAMBDA_AUTH_HEADER_VALUE,
      },
    });

    return response;
  } catch (error) {
    console.error(error);
    throw new Error('Failed to submit shareit');
  }
};
